import React, { SVGProps } from 'react';

const SvgMakers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="119"
    height="81"
    viewBox="0 0 119 81"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <g stroke="#080808">
        <g>
          <path
            d="M3.758 4L3.758 20.971 18.763 60.964 69.318 47.271"
            transform="translate(-1232 -1699) translate(1232.965 1699.158) rotate(6 36.538 32.482)"
          />

          <path
            d="M17.117 50.739l49.118-.25 3.66-2.679c1.48-1.082 1.801-3.159.719-4.638-.201-.275-.444-.518-.719-.719-2.18-1.595-5.141-1.595-7.321 0-2.18 1.595-5.142 1.595-7.322 0-2.18-1.595-5.141-1.595-7.321 0-2.18 1.595-5.142 1.595-7.321 0-2.18-1.595-5.142-1.595-7.322 0l-.344.252c-2.06 1.507-4.756 1.833-7.116.86-2.482-1.023-5.204-1.319-7.847-.853l-1.717.303h0l.853 7.724z"
            transform="translate(-1232 -1699) translate(1232.965 1699.158) rotate(-9 44.91 45.257)"
          />

          <path
            d="M3.494 30.391H26l-.008-2.63c-.003-.732-.598-1.324-1.33-1.321-.156 0-.31.028-.455.082-1.176.433-2.42.655-3.674.655H4.571c-.966 0-1.749.783-1.749 1.75 0 .388.13.765.367 1.072l.305.392h0z"
            transform="translate(-1232 -1699) translate(1232.965 1699.158) rotate(75 13.5 28.129)"
          />

          <path
            d="M20.73 36.66h27.79c1.904 0 3.766-.56 5.355-1.608.404-.266.515-.81.249-1.213-.162-.246-.437-.394-.731-.394H22.008c-1.028 0-1.861.833-1.861 1.861 0 .512.21 1.002.583 1.353h0z"
            transform="translate(-1232 -1699) translate(1232.965 1699.158) rotate(-10 36.82 35.052)"
          />

          <path
            d="M4.692 9.612h11.253l.893-1.071c.517-.621.517-1.523 0-2.143-.411-.493-1.144-.56-1.637-.149-.054.045-.104.095-.149.149-.566.679-1.404 1.071-2.288 1.071H8.411c-.884 0-1.722-.392-2.288-1.071-.41-.493-1.143-.56-1.636-.149-.054.045-.104.095-.15.149-.535.643-.612 1.553-.19 2.277l.545.937h0z"
            transform="translate(-1232 -1699) translate(1232.965 1699.158) rotate(96 10.588 7.47)"
          />

          <path
            d="M12.578 45.257l11.1-3.073 3.043-.843c5.855-1.62 11.915 1.812 13.536 7.667.639 2.306.507 4.758-.374 6.984l-5.768 14.567h0L14.22 75.78v3.903M34.115 70.559L55.884 76.173 55.884 79.684M81.808 46.418L112.517 46.418M97.162 46.418L97.162 70.559M81.808 79.684L81.808 75.121 97.162 70.559 112.517 75.121 112.517 79.684M81.808 43.786h30.709l2.436-1.608c.888-.585 1.133-1.78.547-2.667-.143-.217-.33-.403-.547-.547-1.478-.975-3.395-.975-4.873 0-1.478.975-3.395.975-4.873 0-1.478-.975-3.395-.975-4.873 0-1.478.975-3.395.975-4.873 0-1.478-.975-3.395-.975-4.873 0-1.478.975-3.395.975-4.873 0-1.478-.975-3.395-.975-4.873 0-1.066.703-1.36 2.138-.657 3.204.098.149.213.285.342.408l1.281 1.21h0z"
            transform="translate(-1232 -1699) translate(1232.965 1699.158)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgMakers;
